import {
  CREATE_PENGATURAN_RADIUS_SUCCESS,
  CREATE_PENGATURAN_RADIUS_FAIL,
  RETRIEVE_PENGATURAN_RADIUS_SUCCESS,
  RETRIEVE_PENGATURAN_RADIUS_FAIL,
  UPDATE_PENGATURAN_RADIUS_SUCCESS,
  UPDATE_PENGATURAN_RADIUS_FAIL,
  DELETE_PENGATURAN_RADIUS_SUCCESS,
  DELETE_PENGATURAN_RADIUS_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_PENGATURAN_RADIUS_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_PENGATURAN_RADIUS_SUCCESS:
      return payload;

    case RETRIEVE_PENGATURAN_RADIUS_FAIL:
      return [...datas];

    case UPDATE_PENGATURAN_RADIUS_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_PENGATURAN_RADIUS_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
